import { observer } from "mobx-react-lite";
import SmartAppBase from "../../components/apps/SmartAppBase";
import { analysisAndSegmentationApp } from "../../services/apps/SmartApps";
import useThemeService from 'e.sic-platform.webclient/src/services/theme-service/ThemeService';
import { FileUpload } from "@mui/icons-material";
import SmartAppStep from "../../components/apps/SmartAppStep";
import VideoSegmentationPlayer from "../video-segmentation/components/VideoSegmentationPlayer";
import VideoAnalysisDiagramSection from "../video-analysis/components/VideoAnalysisDiagramSection";
import ExportButton from "../../components/buttons/app-action-buttons/ExportButton";

export default observer(function AnalysisAndSegmentationPage() {
    const videoSegmentation = analysisAndSegmentationApp.services.videoSegmentation!;
    const videoAnalysis = analysisAndSegmentationApp.services.videoAnalysis!;
    const {themeClass} = useThemeService();
    
    if (videoAnalysis.analysisSuccessful) analysisAndSegmentationApp.setStep(3);

    return (
        <SmartAppBase 
            appStorage={analysisAndSegmentationApp} 
            icon={{
                svg: FileUpload,
                textKey: "RunAnalysisAndSegmentation.run",
                className: themeClass(["icon-custom"]),
            }}
            actionBar={<ExportButton exportVideoAnalaysis={videoAnalysis.exportVideoAnalysis} disabled={!videoAnalysis.analysisSuccessful || videoAnalysis.isLoading}/>}
        >
            <SmartAppStep 
                appStorage={analysisAndSegmentationApp}
                titleKey="analysis-and-segmentation.segmentation.title" 
                descriptionKey="analysis-and-segmentation.segmentation.description"
                visible={videoSegmentation.fileId !== undefined && videoSegmentation.video !== undefined}
            	step={2}
            >
                <VideoSegmentationPlayer videoSegmentation={videoSegmentation} />
            </SmartAppStep>
            <SmartAppStep
                appStorage={analysisAndSegmentationApp}
                titleKey="analysis-and-segmentation.analysis.title" 
                descriptionKey="analysis-and-segmentation.analysis.description"
                visible={videoAnalysis.video !== undefined && videoAnalysis.video.isConverted}
            	step={3}
            >
                <VideoAnalysisDiagramSection videoAnalysis={videoAnalysis} />
            </SmartAppStep>
        </SmartAppBase>
    )
})